// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3CvSg","errors":"Errors_errors__3YM5R"};